import React, { Component } from 'react'
import { Button, DialogContainer, Toolbar, FontIcon } from 'react-md';
import LoadingSpinner from './LoadingSpinner';
import { NotificationManager } from 'react-notifications';
import '../css/custom.css'


class ViewRawDataModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    handleIframeLoad = () => {
        const iframe = document.querySelector(".iframe-view-rawdata");
        if (iframe && iframe.contentDocument) {
            const style = document.createElement("style");
            style.innerHTML = `
                .md-paper.md-drawer--left {display: none !important}
                .md-drawer-relative { margin-left: 0 !important}
            `;
            iframe.contentDocument.head.appendChild(style);
        }
        this.setState( {
            loading: false
        })

    };

    handleCopyUrl = () => {
        navigator.clipboard.writeText(this.props.url).then(() => {
            NotificationManager.success('Assignment view raw data link is copied to your clipboard', 'Success', 3000);
        }).catch(err => {
            NotificationManager.error('Failed to copy Assignment view raw data link', 'Error', 3000);
        });
    };

    render() {
        return (
            <div>
                <DialogContainer
                    id="raw-data-dialog"
                    visible={this.props.visible}
                    fullPage
                    focusOnMount={false}
                    aria-label="Assignment Raw Data Dialog"
                >
                    <Toolbar
                        title={
                            <div className='view-rawdata-popup-toolbar-title'>
                                <span style={{fontSize: '1.5rem'}}>Assignment Results</span>
                                <Button
                                    icon
                                    onClick={this.handleCopyUrl}
                                    tooltipLabel="Copy Assignment View Raw Data link"
                                    key="copy"
                                    style={{ marginLeft: '10px', padding: ".5rem 1rem", display: "flex", alignItems: "center", justifyContent: "center" }}
                                >
                                    <FontIcon style={{fontSize:'2rem'}}>link</FontIcon>
                                </Button>
                            </div>
                        }
                        actions={[
                            <Button
                                icon
                                onClick={this.props.handleCloseModal}
                                key="close"
                            >
                                close
                            </Button>
                        ]}
                        className="raw-data-dialog-toolbar"
                    />
                        {this.state.loading ? <LoadingSpinner loading={this.state.loading} /> : null}
                        <iframe
                            className='iframe-view-rawdata'
                            style={{
                                width: "100%",
                                height: "90%",
                                opacity: this.state.loading ? 0 : 1,
                            }}
                            onLoad={this.handleIframeLoad}
                            src={this.props.url}>

                        </iframe>
                </DialogContainer>
            </div>
        )
    }
}

export default ViewRawDataModal;
